module.exports = __webpack_public_path__ + "static/media/sfx_amb_fades_04.c0de194c.mp3";